import {
    setModalContent
} from 'src/redux/modules/modalEvent';
import { useDispatch } from 'react-redux';
import './MatchScoreModal.scss';
import Button from 'src/components/base/Button/Button';
import MatchScoreDisclaimerModal from 'src/latest/src/components/MatchScoreConfirmationModal/MatchScoreDisclaimerModal';
import MatchScoreInvitationModal from 'src/latest/src/components/MatchScoreConfirmationModal/MatchScoreInvitationModal';

const MatchScoreModal = () => {
  const dispatch = useDispatch();

  const handleYesClick = () => {
    dispatch(
      setModalContent({
        modalContent: <MatchScoreDisclaimerModal />,
        isWithCancelButton: false,
        size: 'lg',
        title: 'Calculate Match Score',
        className: 'match-score-modal',
      }),
    );
  };

  const handleClick = () => {
    dispatch(
      setModalContent({
        modalContent: (
          <MatchScoreInvitationModal handleYesClick={handleYesClick} />
        ),
        isWithCancelButton: false,
        size: 'lg',
        title: 'Calculate Match Score',
        className: 'match-score-modal ',
      }),
    );
  };

  return <Button label={'Calculate Your Match Scores'} onClick={handleClick} />;
};

export default MatchScoreModal;
